import { cloneDeep } from 'lodash';
import { useMemo } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { ContentTypeFilter, Filters, TopReadsRange, TopReadsResponse } from '../../models';
import { fetchTopReads } from '../../services/topReads/topReads.service';
import { getContentTypeFilters } from '../../utils/contentTypeUtils';
import { getGroupedFilterTags, getTitleContainsFilter } from '../../utils/filterUtils';
import { mapArticleListItemDtoToArticleTableRow } from '../articles/utils/article.mappers';
import { queryKeys } from '../queryKeyFactory';

export default (
  myCS: boolean,
  filters: Filters | null,
  contentTypeFilter: ContentTypeFilter
): UseQueryResult<TopReadsResponse, Error> => {
  const topReadsTags = useMemo(() => {
    const contentTypeTags = getContentTypeFilters(contentTypeFilter);

    if (!filters) {
      return [contentTypeTags];
    }

    return [...getGroupedFilterTags(cloneDeep(filters)), contentTypeTags];
  }, [filters, myCS, contentTypeFilter]);

  const titleContainsFilter = getTitleContainsFilter(filters?.titleContains);
  const startDate = filters?.startDate;
  const endDate = filters?.endDate;
  return useQuery<TopReadsResponse, Error>(
    queryKeys.fetchTopReads.query({
      myCS,
      tags: topReadsTags,
      textContains: titleContainsFilter,
      startDate,
      endDate,
    }),
    async () => {
      const response = await Promise.all([
        fetchTopReads(TopReadsRange.DAY, myCS, topReadsTags!, titleContainsFilter, startDate, endDate),
        fetchTopReads(TopReadsRange.WEEK, myCS, topReadsTags!, titleContainsFilter, startDate, endDate),
        fetchTopReads(TopReadsRange.MONTH, myCS, topReadsTags!, titleContainsFilter, startDate, endDate),
      ]);
      return {
        [TopReadsRange.DAY]: mapArticleListItemDtoToArticleTableRow(response[0].results),
        [TopReadsRange.WEEK]: mapArticleListItemDtoToArticleTableRow(response[1].results),
        [TopReadsRange.MONTH]: mapArticleListItemDtoToArticleTableRow(response[2].results),
      };
    },
    {
      enabled: !!filters,
    }
  );
};
